// Owner in P4: piece 3 "agent-console" (docs/FILE-OWNERSHIP.md, "The P4 pieces").
// The feature's entry file (docs/CONTRACTS.md sections 16 and 22.6): `/agents`, one lazy chunk. The chosen tab is the URL's
// `tab` search value, the word `activity` or nothing (never free text, section 5). The rail entry is for everyone: each
// person has proposals; the activity tab is the owner's.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Bot } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { parseSearch } from './search.ts'

export const feature: Feature = {
  app: (parent) => [
    createRoute({
      getParentRoute: () => parent,
      path: '/agents',
      validateSearch: (search: Record<string, unknown>) => parseSearch(search),
      component: lazyRouteComponent(() => import('./AgentsScreen.tsx')),
    }),
  ],
  nav: [{ to: '/agents', label: 'nav.agents', icon: Bot, group: 'system' }],
}
